import { render, staticRenderFns } from "./detail-workers.vue?vue&type=template&id=6a5dcdb2&"
import script from "./detail-workers.vue?vue&type=script&lang=js&"
export * from "./detail-workers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports